import React, { useState } from 'react';
import { Dropdown, Badge, Button } from 'antd';
import { CommentOutlined } from '@ant-design/icons';
import { usePatientChart } from '../context/PatientChartContext';
import Chatbox from './Chatbox'; // Import the actual Chatbox component

const ChatIcon = ({ userId, isChatDropdownVisible, onChatDropdownVisibleChange }) => {
  const { activeChartId } = usePatientChart(); // Get active patient ID from context
  const [unreadCount, setUnreadCount] = useState(0); // Placeholder for unread messages

  // Use the active patient ID from the chart context
  const currentPatientId = activeChartId;

  // Debug logging
  console.log('ChatIcon: activeChartId from context:', activeChartId);
  console.log('ChatIcon: currentPatientId:', currentPatientId);
  console.log('ChatIcon: userId:', userId);

  // Handle dropdown visibility change with event propagation control
  const handleDropdownVisibleChange = (visible) => {
    console.log('Dropdown visibility changing to:', visible);
    onChatDropdownVisibleChange(visible);
  };

  // Placeholder for Chatbox component - replace with actual Chatbox
  const chatboxMenu = (
    // The div wrapper controls the size of the dropdown content area
    // Add onClick to stop propagation to prevent drawer from closing
    <div
      style={{
        width: '350px',
        height: '500px',
        border: '1px solid #f0f0f0',
        backgroundColor: '#fff',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.25)',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999
      }}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {currentPatientId ? (
        <Chatbox patientId={currentPatientId} userId={userId} />
      ) : (
        <div style={{ padding: '16px', textAlign: 'center' }}>
          No patient selected. Please select a patient to start a chat.
        </div>
      )}
    </div>
  );

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 10000, // Higher than any other element
        borderRadius: '50%',
        boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
        backgroundColor: '#1890ff',
        transition: 'all 0.3s ease'
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 16px rgba(0, 0, 0, 0.2)';
      }}
    >
      <Dropdown
        dropdownRender={() => chatboxMenu}
        trigger={['click']}
        open={isChatDropdownVisible}
        onOpenChange={handleDropdownVisibleChange}
        placement="topRight"
        getPopupContainer={() => document.body} // Render in body to ensure it's on top
      >
        <Badge count={unreadCount} size="small" offset={[-8, 8]}>
          <Button
            type="primary"
            shape="circle"
            size="large"
            icon={<CommentOutlined style={{ fontSize: '20px' }} />}
            style={{
              width: '56px',
              height: '56px',
              border: 'none',
              backgroundColor: '#1890ff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            onClick={(e) => {
              // Don't prevent default or stop propagation - let the dropdown handle the click
              console.log('Chat icon clicked, current visibility:', isChatDropdownVisible);
              // Manually toggle the dropdown if needed
              onChatDropdownVisibleChange(!isChatDropdownVisible);
            }}
          />
        </Badge>
      </Dropdown>
    </div>
  );
};

export default ChatIcon;
